export const sobre = [
  {
    title: "Nosso Blog",
    url: `https://petanjo.com/blog/`,
    newTab: true
  },
  {
    title: "Política de uso",
    url: `https://www.cobasi.com.br/servicos/politica-de-uso/`,
    newTab: true
  },
  {
    title: "Política de privacidade",
    url: "https://petanjo.com/politica-de-privacidade",
    newTab: true
  },
  {
    title: "Central de ajuda",
    url: `https://atendimentopetanjo.zendesk.com/hc/pt-br/`,
    newTab: true
  },
  {
    title: "Transparência",
    url: `https://petanjo.com/transparencia`,
    newTab: true
  }
];

export const duvidas = [
  /*{
    title: "Ajuda online",
    url: `https://chat.directtalk.com.br/static/?chatId=9e4fa801-e9f5-458f-b754-c57b50bd478f`,
    newTab: true
  },*/
  {
    title: "Atendimento",
    url: "https://atendimento.cobasi.com.br/hc/pt-br",
    newTab: true
  },
  {
    title: "Regulamentos",
    url: `/regulamentos`,
    newTab: true
  },
  {
    title: "Política de entregas",
    url: `/institucional/politica-de-entrega`,
    newTab: true
  },
  {
    title: "Política de privacidade",
    url: `/institucional/politica-de-privacidade`,
    newTab: true
  },
  {
    title: "Troca Fácil",
    url: `/institucional/troca-facil`,
    newTab: true
  },
  {
    title: "Ouvidoria",
    url: "https://atendimento.cobasi.com.br/",
    newTab: true
  }
];

export const cobasi_world = [
  {
    title: "Amigo Cobasi",
    url: `/amigo-cobasi`,
    newTab: true
  },
  {
    title: "Compra Programada",
    url: `/compra-programada`,
    newTab: true
  },
  {
    title: "Cobasi Já",
    url: `/modalidade-de-entrega/cobasi-ja`,
    newTab: true
  },
  {
    title: "Cobasi Cuida",
    url: "https://www.cobasicuida.com.br/",
    newTab: true
  },
  {
    title: "Retirar na Loja",
    url: `/modalidade-de-entrega/retirar-na-loja`,
    newTab: true
  }
];

export const pet_services = [
  {
    title: "Banho e Tosa",
    url: `/servicos/agendamentos/bem-vindo/`,
    newTab: true
  },
  {
    title: "Veterinário",
    url: `/servicos/agendamentos/bem-vindo/`,
    newTab: true
  },
  {
    title: "Pet Sitter",
    url: `/servicos/agendamentos/bem-vindo/`,
    newTab: true
  },
  {
    title: "Hospedagem Pet",
    url: `/servicos/agendamentos/bem-vindo/`,
    newTab: true
  },
  {
    title: "Dog Walker",
    url: `/servicos/agendamentos/bem-vindo/`,
    newTab: true
  },
  {
    title: "Adestramento",
    url: `/servicos/agendamentos/bem-vindo/`,
    newTab: true
  },
  {
    title: "Creche Pet",
    url: `/servicos/agendamentos/bem-vindo/`,
    newTab: true
  },
  {
    title: "Personal Pet",
    url: `/institucional/personal-pet`,
    newTab: true
  },
  {
    title: "Adoção",
    url: "https://cobasicuida.com.br/adocao",
    newTab: true
  },
  {
    title: "Franquia Pet Anjo",
    url: `/institucional/seja-franqueado-pet-anjo`,
    newTab: true
  }
];

export const especiais = [
  {
    title: "Aniversário Cobasi",
    url: `/institucional/aniversario-cobasi`,
    newTab: true
  },
  {
    title: "Marcas Exclusivas",
    url: `/institucional/marcas-exclusivas`,
    newTab: true
  },
  {
    title: "Cupom de desconto",
    url: `/institucional/cupom-de-desconto`,
    newTab: true
  },
  {
    title: "Black Friday",
    url: `/institucional/black-friday-pet`,
    newTab: true
  },
  {
    title: "Ciclo das pulgas",
    url: `/institucional/ciclo-das-pulgas`,
    newTab: true
  },
  {
    title: "Sobre Vermífugos",
    url: `/especiais/tudo-sobre-vermifugos`,
    newTab: true
  },
  {
    title: "Guabi Natural",
    url: `/especiais/guabi-natural`,
    newTab: true
  },
  {
    title: "Farmina N&D",
    url: `/especiais/racao-nd`,
    newTab: true
  },
  {
    title: "Hill's Pet Nutrition",
    url: `/especiais/hills-prescription-diet`,
    newTab: true
  },
  {
    title: "Vet Life",
    url: `/especiais/vet-life`,
    newTab: true
  },
  {
    title: "Pet Day",
    url: `/especiais/pet-day-cobasi`,
    newTab: true
  },
  {
    title: "Minha Loja Cobasi",
    url: `/institucional/crie-sua-loja`,
    newTab: true
  },
  {
    title: "Ajude o Rio Grande do Sul",
    url: `/pesquisa?hotsite=cobasi-sos-rs`
  }
];

export const categories = [
  {
    title: "Cachorro",
    url: "/c/cachorro"
  },
  {
    title: "Gato",
    url: "/c/gatos"
  },
  {
    title: "Pássaros",
    url: "/c/passaros"
  },
  {
    title: "Casa",
    url: "/c/casa"
  },
  {
    title: "Jardim",
    url: "/c/jardim"
  },
  {
    title: "Peixes",
    url: "/c/peixes"
  },
  {
    title: "Outros pets",
    url: "/c/outros-animais"
  }
];

export const racas = [
  {
    title: "Pug",
    url: `/pug`,
    newTab: true
  },
  {
    title: "Rottweiler",
    url: `/rottweiler`,
    newTab: true
  },
  {
    title: "Pitbull",
    url: `/pitbull`,
    newTab: true
  },
  {
    title: "Border Collie",
    url: `/border-collie`,
    newTab: true
  },
  {
    title: "Golden retriever",
    url: `/golden-retriever`,
    newTab: true
  }
];

export const formasDePagamento =
  "Visa, MasterCard, Diners Club, American Express; Boleto bancário; Elo e Apple Pay.";

export const promo =
  "* As promoções, parcerias e descontos contidos em nosso site não são cumulativos. Diante de duas ou mais promoções, será necessário optar por aquela que melhor lhe convém, isentando a Cobasi de qualquer responsabilidade nesse sentido. Preços e condições de pagamento exclusivos para compras via internet, podendo variar nas lojas físicas. Todas as regras e promoções são válidas apenas para produtos vendidos e entregues pela Cobasi. Em caso de divergência de valores no site, o valor válido é o do carrinho de compras.";

export const securePurchaseAndCopy = (year: number) => [
  "COMPRA SEGURA. A Cobasi garante segurança para suas informações pessoais e financeiras.",
  `Copyright ${year}. Todos os direitos reservados à Cobasi.`
];

export const cobasiDados = [
  "COBASI COMÉRCIO DE PRODUTOS BÁSICOS E INDUSTRIALIZADOS S.A.",
  "CNPJ 53.153.938/0016-94 - Av. Fernando Cerqueira César Coimbra, nº 210, Galpão A - Alphaville Industrial, Barueri - SP  CEP: 06465-060"
];

export const mapas = [
  {
    title: "Mapa do site",
    url: `/sitemap`,
    newTab: true
  },
  {
    title: "Mapa de categorias",
    url: `/institucional/categorias`,
    newTab: true
  },
  {
    title: "Mapa de produtos",
    url: `/institucional/produtos`,
    newTab: true
  }
];

export const socialMediasPetAnjo = [
  {
    name: "Facebook",
    icon: "https://images.cobasi.com.br/cms/assets/social_icon_facebook_coffee_418555267d.svg",
    iconBF:
      "https://cms.cobasi.com.br/uploads/social_facebook_white_e273b35d64.png",
    link: "https://www.facebook.com/petanjo"
  },
  {
    name: "Instagram",
    icon: "https://images.cobasi.com.br/cms/assets/social_icon_instagram_coffee_1435ea8fce.png",
    iconBF:
      "https://cms.cobasi.com.br/uploads/social_instagram_white_3da865d5b7.png",
    link: "https://www.instagram.com/petanjo"
  },
  {
    name: "Youtube",
    icon: "https://images.cobasi.com.br/cms/assets/social_icon_youtube_coffee_80ba69e0f0.png",
    iconBF:
      "https://cms.cobasi.com.br/uploads/social_youtube_white_12580da744.png",
    link: "https://www.youtube.com/channel/UCvCg_7bkbqbsokKV3UOqpsg"
  }
];

export const appCobasi = [
  {
    name: "App Store",
    icon: "https://cms.cobasi.com.br/uploads/app_store_footer_f624fa367c.svg",
    link: "https://itunes.apple.com/br/app/cobasi/id1237962997?mt=8",
    testId: "download-app-store"
  },
  {
    name: "Google Play",
    icon: "https://cms.cobasi.com.br/uploads/google_play_footer_984d6ba60d.svg",
    link: "https://play.google.com/store/apps/details?id=com.root.cobasi.Activities",
    testId: "download-google-play"
  }
];
